import { render } from "./DognutChart.vue?vue&type=template&id=6e3be2ae"
import script from "./DognutChart.vue?vue&type=script&lang=js"
export * from "./DognutChart.vue?vue&type=script&lang=js"
script.render = render

export default script